import capitalize from 'lodash/capitalize';
import { getToolDisplay, type ToolDisplay } from '../components/chat-message';
import type { ChatMessage as ChatMessageData } from '../hooks/use-chat-ws';

export const hasVisibleContent = (msg: ChatMessageData, isThinking?: boolean): boolean => {
  if (msg.type === 'tool_use') return getToolDisplay(msg.tool, msg.input) !== null;
  // task_progress is a live indicator — hide once the agent stops thinking, since the
  // tool calls below already show what was done.
  if (msg.type === 'task_progress') return isThinking ?? true;
  return false;
};

export const summarizeToolCalls = (messages: ChatMessageData[]): string => {
  // Group by tool name so each tool's `summarize` runs over its own count.
  const grouped = new Map<string, { info: ToolDisplay; count: number }>();
  for (const m of messages) {
    if (m.type !== 'tool_use') continue;
    const info = getToolDisplay(m.tool, m.input);
    if (!info) continue;
    const entry = grouped.get(m.tool);
    if (entry) entry.count += 1;
    else grouped.set(m.tool, { info, count: 1 });
  }
  const parts: string[] = [];
  for (const { info, count } of grouped.values()) {
    parts.push(info.summarize ? info.summarize(count) : count > 1 ? `${info.label} (${count})` : info.label);
  }
  if (!parts.length) return '';
  return capitalize(parts.join(', '));
};
